import React, { Component } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { platform } from "../../Style";
import OVVRequestForm from "./OVVRequestForm";
import {
  getRequests
} from "../../actions/OVVRequests";
import LoadPage from "../Load/LoadPage";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import jwt_decode from "jwt-decode";
import { SignalCellularNullOutlined } from "@mui/icons-material";

export class OVVRequests extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      rowsPerPage: 5,
      project: null,
      infoToken: null,
      load: true,
      reportFormatUrl: "",
      selectedRequest: null,
      requests: [],
    };
  }


  componentDidMount() {
    const infoToken = this.props.token ? jwt_decode(this.props.token) : {};
    this.setState({
      infoToken
    })
    this.loadProjectsRequests();
  }

  loadProjectsRequests = () => {
    const { projectId } = this.props.match.params;
    this.setState({
      load: true,
    });
    getRequests(projectId).then((response) => {
      if (response.status) {
        this.setState({
          project: response.project,
          requests: response.requests,
          reportFormatUrl: response.reportFormatUrl,
          load: false,
        });
      }
    });
  };

  loadMainPage = () => {
    this.loadProjectsRequests();
  };

  downloadReport = () => {
    const { reportFormatUrl } = this.state
    window.open(reportFormatUrl, "_blank");
  }
  render() {
    const {
      requests,
      project,
      load,
      infoToken
    } = this.state;

    const { t } = this.props;

    return (
      <Container className="mt-4">
        <LoadPage load={load} />
        <Row className="mb-3">
          <Col>
            <h1 style={{ color: "#59B089", fontWeight: 700 }}>
              {t("project")} {project && project.name}
            </h1>
            <hr style={{ borderTop: "5px solid #59B089" }} />
          </Col>
        </Row>
        <Row className="mb-3">
          <Col xs={12} md={6} lg={6}>
            <h2 style={{ color: "#59B089", fontWeight: 700 }}>
              {t("ovvRequests.ovvRequests")}
            </h2>
          </Col>
          {infoToken && infoToken.typeAccount && infoToken.typeAccount === "ovv" &&
            <Col xs={12} md={6} lg={6}>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  style={platform.buttonSuccess}
                  onClick={() => {
                    this.downloadReport()
                  }}
                >
                  {t("ovvRequests.downloadReportTemplate")}
                </Button>
              </div>
            </Col>
          }
        </Row>
        <OVVRequestForm
          project={project}
          token={infoToken}
          requests={requests}
          recharge={() => {
            this.loadMainPage();
          }}
        />
      </Container>
    );
  }
}

const mapStateToProps = ({ user }) => ({
  token: user.token
});

export default connect(mapStateToProps)(withTranslation()(OVVRequests));
